import * as React from "react";

import { useTheme, useMediaQuery } from "@mui/material";

import { PurchaseStepMobile } from "./PurchaseStepMobile";

import { PurchaseStepDesktop } from "./PurchaseStepDesktop";

export function PurchaseStep() {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return isMobile ? <PurchaseStepMobile /> : <PurchaseStepDesktop />;
}
